
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"25","viewBox":"0 0 24 25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.9999 13.8674C13.723 13.8674 15.1199 12.4706 15.1199 10.7474C15.1199 9.02431 13.723 7.62744 11.9999 7.62744C10.2768 7.62744 8.87988 9.02431 8.87988 10.7474C8.87988 12.4706 10.2768 13.8674 11.9999 13.8674Z","stroke":"currentColor","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M3.61995 8.9275C5.58995 0.267502 18.42 0.277503 20.38 8.9375C21.53 14.0175 18.37 18.3175 15.6 20.9775C13.59 22.9175 10.41 22.9175 8.38995 20.9775C5.62995 18.3175 2.46995 14.0075 3.61995 8.9275Z","stroke":"currentColor","stroke-width":"1.5"}})])
          )
        }
      }
    